import * as React from "react";

import { cn } from "../lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // Forms design language — matches the Input primitive (px sized).
        "flex min-h-[84px] w-full rounded-[var(--forms-input-radius)] border-[length:var(--forms-input-border-w)] border-[var(--forms-border)] bg-white px-[var(--forms-input-px)] py-[var(--forms-input-py)] text-[length:var(--forms-input-font)] leading-[1.4] text-[var(--forms-ink)] transition-[border-color,box-shadow,background-color] placeholder:text-[var(--forms-faint)] [&[placeholder]:not(:placeholder-shown):not(:focus)]:border-[var(--forms-input-filled-border)] [&[placeholder]:not(:placeholder-shown):not(:focus)]:bg-[var(--forms-input-filled-bg)] focus-visible:border-[var(--forms-accent,var(--forms-accent-default))] focus-visible:shadow-[0_0_0_3px_var(--forms-accent-ring,var(--forms-accent-ring-default))] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
